import { h as C, openBlock as f, createElementBlock as y, createElementVNode as l, renderSlot as k, pushScopeId as v, popScopeId as g, resolveComponent as A, createVNode as O, withCtx as P } from "vue";
const T = "@james090500/vue-stripe", j = "4.4.7", B = "Stripe Checkout & Elements for Vue.js", L = "jofftiquez@gmail.com", R = "module", x = [
  "dist"
], D = "./dist/vue-stripe.mjs", F = "./dist/vue-stripe.js", V = "dist/vue-stripe.d.ts", U = {
  dev: "vite",
  build: "vite build && vue-tsc --declaration --emitDeclarationOnly",
  preview: "vite preview --port 4173",
  prepare: "npm run build",
  declartion: "vue-tsc --declaration --emitDeclarationOnly",
  publish: "npm version patch --force && npm publish"
}, q = {
  "@stripe/stripe-js": "^1.46.0",
  vue: "^3.2.45",
  "vue-coerce-props": "^1.0.0"
}, N = {
  "@rushstack/eslint-patch": "^1.2.0",
  "@types/node": "^18.11.18",
  "@vitejs/plugin-vue": "^4.0.0",
  "@vue/eslint-config-prettier": "^7.0.0",
  eslint: "^8.31.0",
  "eslint-plugin-vue": "^9.8.0",
  "npm-run-all": "^4.1.5",
  prettier: "^2.8.1",
  vite: "^4.0.4",
  "vite-plugin-html": "^3.2.0",
  "vue-tsc": "^1.0.22"
}, M = {
  url: "https://github.com/james090500/vue-stripe/issues"
}, z = "https://github.com/james090500/vue-stripe#readme", W = [
  "vue",
  "vuejs",
  "stripe",
  "checkout",
  "payment"
], Y = "MIT", G = {
  type: "git",
  url: "git@github.com:james090500/vue-stripe.git"
}, H = {
  name: T,
  version: j,
  description: B,
  author: L,
  type: R,
  files: x,
  main: D,
  module: F,
  typings: V,
  scripts: U,
  dependencies: q,
  devDependencies: N,
  bugs: M,
  homepage: z,
  keywords: W,
  license: Y,
  repository: G
}, m = "auto", X = [
  "auto",
  "bg",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "en-GB",
  "es",
  "es-419",
  "et",
  "fi",
  "fr",
  "fr-CA",
  "hu",
  "id",
  "it",
  "ja",
  "lt",
  "lv",
  "ms",
  "mt",
  "nb",
  "nl",
  "pl",
  "pt",
  "pt-BR",
  "ro",
  "ru",
  "sk",
  "sl",
  "sv",
  "tr",
  "zh",
  "zh-HK",
  "zh-TW"
], J = ["auto", "book", "donate", "pay"], K = ["required", "auto"], Q = {
  base: {
    color: "#32325d",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4"
    }
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a"
  }
}, Z = H.version, c = {
  name: "vue-stripe",
  version: Z,
  url: "https://vuestripe.com",
  partner_id: "pp_partner_IqtOXpBSuz0IE2"
}, we = {
  install: (e, t) => {
    const { pk: n, stripeAccount: i, apiVersion: r, locale: s } = t, o = window.Stripe(n, { stripeAccount: i, apiVersion: r, locale: s });
    o.registerAppInfo(c), e.config.globalProperties.$stripe = o;
  }
};
function u(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? u = function(t) {
    return typeof t;
  } : u = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u(e);
}
var S = "https://js.stripe.com/v3", ee = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, h = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", te = function() {
  for (var t = document.querySelectorAll('script[src^="'.concat(S, '"]')), n = 0; n < t.length; n++) {
    var i = t[n];
    if (ee.test(i.src))
      return i;
  }
  return null;
}, ne = function(t) {
  var n = t && !t.advancedFraudSignals ? "?advancedFraudSignals=false" : "", i = document.createElement("script");
  i.src = "".concat(S).concat(n);
  var r = document.head || document.body;
  if (!r)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return r.appendChild(i), i;
}, ie = function(t, n) {
  !t || !t._registerWrapper || t._registerWrapper({
    name: "stripe-js",
    version: "1.46.0",
    startTime: n
  });
}, d = null, re = function(t) {
  return d !== null || (d = new Promise(function(n, i) {
    if (typeof window > "u") {
      n(null);
      return;
    }
    if (window.Stripe && t && console.warn(h), window.Stripe) {
      n(window.Stripe);
      return;
    }
    try {
      var r = te();
      r && t ? console.warn(h) : r || (r = ne(t)), r.addEventListener("load", function() {
        window.Stripe ? n(window.Stripe) : i(new Error("Stripe.js not available"));
      }), r.addEventListener("error", function() {
        i(new Error("Failed to load Stripe.js"));
      });
    } catch (s) {
      i(s);
      return;
    }
  })), d;
}, se = function(t, n, i) {
  if (t === null)
    return null;
  var r = t.apply(void 0, n);
  return ie(r, i), r;
}, oe = function(t) {
  var n = `invalid load parameters; expected object of shape

    {advancedFraudSignals: boolean}

but received

    `.concat(JSON.stringify(t), `
`);
  if (t === null || u(t) !== "object")
    throw new Error(n);
  if (Object.keys(t).length === 1 && typeof t.advancedFraudSignals == "boolean")
    return t;
  throw new Error(n);
}, b, _ = !1, a = function() {
  for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++)
    n[i] = arguments[i];
  _ = !0;
  var r = Date.now();
  return re(b).then(function(s) {
    return se(s, n, r);
  });
};
a.setLoadParameters = function(e) {
  if (_)
    throw new Error("You cannot change load parameters after calling loadStripe");
  b = oe(e);
};
/**
 * vue-coerce-props v1.0.0
 * (c) 2018 Eduardo San Martin Morote <posva13@gmail.com>
 * @license MIT
 */
var le = {
  beforeCreate: function() {
    var t = this.$options, n = t.props;
    n && (this._$coertions = Object.keys(n).filter(function(i) {
      return n[i].coerce;
    }).map(function(i) {
      return [i, n[i].coerce];
    }));
  },
  computed: {
    $coerced: function() {
      var t = this;
      return this._$coertions.reduce(function(n, i) {
        var r = i[0], s = i[1];
        return n[r] = s.call(t, t.$props[r]), n;
      }, {});
    }
  }
};
const ae = {
  pk: {
    type: String,
    required: !0
  },
  mode: {
    type: String,
    validator: (e) => ["payment", "subscription"].includes(e)
  },
  lineItems: {
    type: Array,
    default: void 0
  },
  items: {
    type: Array
  },
  successUrl: {
    type: String,
    default: window.location.href
  },
  cancelUrl: {
    type: String,
    default: window.location.href
  },
  submitType: {
    type: String,
    validator: (e) => J.includes(e)
  },
  billingAddressCollection: {
    type: String,
    default: "auto",
    validator: (e) => K.includes(e)
  },
  clientReferenceId: {
    type: String
  },
  customerEmail: {
    type: String
  },
  sessionId: {
    type: String
  },
  stripeAccount: {
    type: String,
    default: void 0
  },
  apiVersion: {
    type: String,
    default: void 0
  },
  locale: {
    type: String,
    default: m,
    coerce: (e) => X.includes(e) ? e : (console.warn(
      `VueStripe Warning: '${e}' is not supported by Stripe yet. Falling back to default '${m}'.`
    ), m)
  },
  shippingAddressCollection: {
    type: Object,
    validator: (e) => Object.prototype.hasOwnProperty.call(e, "allowedCountries")
  },
  disableAdvancedFraudDetection: {
    type: Boolean
  },
  stripeOptions: {
    type: Object,
    default: null
  }
}, Ie = {
  props: ae,
  mixins: [le],
  render() {
    return C("div", this.$slots.default ? this.$slots.default() : []);
  },
  // FIXME: temporarily remove to avoid problems with remote non-production deployments
  // mounted () {
  //   if (!isSecureHost()) console.warn(INSECURE_HOST_ERROR_MESSAGE);
  // },
  methods: {
    async redirectToCheckout() {
      try {
        this.$emit("loading", !0), this.disableAdvancedFraudDetection && a.setLoadParameters({ advancedFraudSignals: !1 });
        const e = {
          stripeAccount: this.stripeAccount,
          apiVersion: this.apiVersion,
          locale: this.locale
        }, t = await a(this.pk, e);
        if (t.registerAppInfo(c), this.sessionId) {
          t.redirectToCheckout({
            sessionId: this.sessionId
          });
          return;
        }
        if (this.lineItems && this.lineItems.length && !this.mode) {
          console.error(
            "Error: Property 'mode' is required when using 'lineItems'. See https://stripe.com/docs/js/checkout/redirect_to_checkout#stripe_checkout_redirect_to_checkout-options-mode"
          );
          return;
        }
        const n = {
          billingAddressCollection: this.billingAddressCollection,
          cancelUrl: this.cancelUrl,
          clientReferenceId: this.clientReferenceId,
          customerEmail: this.customerEmail,
          items: this.items,
          lineItems: this.lineItems,
          locale: this.$coerced.locale,
          mode: this.mode,
          shippingAddressCollection: this.shippingAddressCollection,
          submitType: this.submitType,
          successUrl: this.successUrl
        };
        return t.redirectToCheckout(n);
      } catch (e) {
        console.error(e), this.$emit("error", e);
      }
    }
  }
};
const E = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, r] of t)
    n[i] = r;
  return n;
}, ce = "card", de = {
  props: {
    pk: {
      type: String,
      required: !0
    },
    testMode: {
      type: Boolean,
      default: !1
    },
    stripeAccount: {
      type: String,
      default: void 0
    },
    apiVersion: {
      type: String,
      default: void 0
    },
    locale: {
      type: String,
      default: "auto"
    },
    elementsOptions: {
      type: Object,
      default: () => ({})
    },
    tokenData: {
      type: Object,
      default: () => ({})
    },
    disableAdvancedFraudDetection: {
      type: Boolean
    },
    // element specific options
    classes: {
      type: Object,
      default: () => ({})
    },
    elementStyle: {
      type: Object,
      default: () => Q
    },
    value: {
      type: String,
      default: void 0
    },
    hidePostalCode: Boolean,
    iconStyle: {
      type: String,
      default: "default",
      validator: (e) => ["solid", "default"].includes(e)
    },
    hideIcon: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      loading: !1,
      stripe: null,
      elements: null,
      element: null,
      card: null
    };
  },
  computed: {
    form() {
      return document.getElementById("stripe-element-form");
    }
  },
  async mounted() {
    this.disableAdvancedFraudDetection && a.setLoadParameters({
      advancedFraudSignals: !1
    });
    const e = {
      stripeAccount: this.stripeAccount,
      apiVersion: this.apiVersion,
      locale: this.locale
    }, t = {
      classes: this.classes,
      style: this.elementStyle,
      value: this.value,
      hidePostalCode: this.hidePostalCode,
      iconStyle: this.iconStyle,
      hideIcon: this.hideIcon,
      disabled: this.disabled
    };
    this.stripe = await a(this.pk, e), this.stripe.registerAppInfo(c), this.elements = this.stripe.elements(this.elementsOptions), this.element = this.elements.create(ce, t), this.element.mount("#stripe-element-mount-point"), this.element.on("change", (n) => {
      var i = document.getElementById("stripe-element-errors");
      n.error ? i.textContent = n.error.message : i.textContent = "", this.onChange(n);
    }), this.element.on("blur", this.onBlur), this.element.on("click", this.onClick), this.element.on("escape", this.onEscape), this.element.on("focus", this.onFocus), this.element.on("ready", this.onReady), this.form.addEventListener("submit", async (n) => {
      try {
        this.$emit("loading", !0), n.preventDefault();
        const i = {
          ...this.element
        };
        this.amount && (i.amount = this.amount);
        const { token: r, error: s } = await this.stripe.createToken(
          i,
          this.tokenData
        );
        if (s) {
          const o = document.getElementById("stripe-element-errors");
          o.textContent = s.message, this.$emit("error", s);
          return;
        }
        this.$emit("token", r);
      } catch (i) {
        console.error(i), this.$emit("error", i);
      } finally {
        this.$emit("loading", !1);
      }
    });
  },
  methods: {
    /**
     * Triggers the submission of the form
     * @return {void}
     */
    submit() {
      this.$refs.submitButtonRef.click();
    },
    /**
     * Clears the element
     * @return {void}
     */
    clear() {
      this.element.clear();
    },
    /**
     * Destroys the element
     * @return {void}
     */
    destroy() {
      this.element.destroy();
    },
    /**
     * Focuses on the element
     * @return {void}
     */
    focus() {
      console.warn(
        "This method will currently not work on iOS 13+ due to a system limitation."
      ), this.element.focus();
    },
    /**
     * Unmounts the element
     * @return {void}
     */
    unmount() {
      this.element.unmount();
    },
    /**
     * Updates the element
     * @param {string} opts.classes.base The base class applied to the container. Defaults to StripeElement.
     * @param {string} opts.classes.complete The class name to apply when the Element is complete. Defaults to StripeElement--complete.
     * @param {string} opts.classes.empty The class name to apply when the Element is empty. Defaults to StripeElement--empty.
     * @param {string} opts.classes.focus The class name to apply when the Element is focused. Defaults to StripeElement--focus.
     * @param {string} opts.classes.invalid The class name to apply when the Element is invalid. Defaults to StripeElement--invalid.
     * @param {string} opts.classes.webkitAutoFill The class name to apply when the Element has its value autofilled by the browser (only on Chrome and Safari). Defaults to StripeElement--webkit-autofill.
     * @param {Object} opts.style Customize the appearance of this element using CSS properties passed in a Style object.
     * @param {string} opts.value A pre-filled set of values to include in the input (e.g., {postalCode: '94110'}). Note that sensitive card information (card number, CVC, and expiration date) cannot be pre-filled
     * @param {boolean} opts.hidePostalCode Hide the postal code field. Default is false. If you are already collecting a full billing address or postal code elsewhere, set this to true.
     * @param {string} opts.iconStyle Appearance of the icon in the Element. Either solid or default.
     * @param {boolean} opts.hideIcon Hides the icon in the Element. Default is false.
     * @param {boolean} opts.disabled Applies a disabled state to the Element such that user input is not accepted. Default is false.
     */
    update(e) {
      this.element.update(e);
    },
    // events
    onChange(e) {
      this.$emit("element-change", e);
    },
    onReady(e) {
      this.$emit("element-ready", e);
    },
    onFocus(e) {
      this.$emit("element-focus", e);
    },
    onBlur(e) {
      this.$emit("element-blur", e);
    },
    onEscape(e) {
      this.$emit("element-escape", e);
    },
    onClick(e) {
      this.$emit("element-click", e);
    }
  }
}, $ = (e) => (v("data-v-b01fb89a"), e = e(), g(), e), ue = { id: "stripe-element-form" }, pe = /* @__PURE__ */ $(() => /* @__PURE__ */ l("div", { id: "stripe-element-mount-point" }, null, -1)), me = /* @__PURE__ */ $(() => /* @__PURE__ */ l("div", {
  id: "stripe-element-errors",
  role: "alert"
}, null, -1)), he = {
  ref: "submitButtonRef",
  type: "submit",
  class: "hide"
};
function fe(e, t, n, i, r, s) {
  return f(), y("div", null, [
    l("form", ue, [
      pe,
      k(e.$slots, "stripe-element-errors", {}, () => [
        me
      ], !0),
      l("button", he, null, 512)
    ])
  ]);
}
const Ce = /* @__PURE__ */ E(de, [["render", fe], ["__scopeId", "data-v-b01fb89a"]]);
const ye = "payment", ve = {
  props: {
    pk: {
      type: String,
      required: !0
    },
    testMode: {
      type: Boolean,
      default: !1
    },
    elementsOptions: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    confirmParams: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    redirect: {
      type: String,
      default: "always"
    },
    createOptions: {
      type: Object,
      default: () => ({})
    },
    stripeAccount: {
      type: String,
      default: void 0
    },
    apiVersion: {
      type: String,
      default: void 0
    },
    locale: {
      type: String,
      default: "auto"
    },
    disableAdvancedFraudDetection: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: !1,
      stripe: null,
      elements: null,
      element: null
    };
  },
  computed: {
    form() {
      return document.getElementById("stripe-payment-element-form");
    }
  },
  async mounted() {
    this.disableAdvancedFraudDetection && a.setLoadParameters({
      advancedFraudSignals: !1
    });
    const e = {
      stripeAccount: this.stripeAccount,
      apiVersion: this.apiVersion,
      locale: this.locale
    };
    this.stripe = await a(this.pk, e), this.stripe.registerAppInfo(c), this.elements = this.stripe.elements(this.elementsOptions), this.element = this.elements.create(ye, this.createOptions), this.element.mount("#stripe-payment-element-mount-point"), this.element.on("change", (t) => {
      var n = document.getElementById(
        "stripe-payment-element-errors"
      );
      t.error ? n.textContent = t.error.message : n.textContent = "", this.onChange(t);
    }), this.element.on("blur", this.onBlur), this.element.on("click", this.onClick), this.element.on("escape", this.onEscape), this.element.on("focus", this.onFocus), this.element.on("ready", this.onReady), this.form.addEventListener("submit", async (t) => {
      try {
        this.$emit("loading", !0), t.preventDefault();
        const { error: n } = await this.stripe.confirmPayment({
          elements: this.elements,
          confirmParams: this.confirmParams,
          redirect: this.redirect
        });
        if (n) {
          const i = document.getElementById(
            "stripe-payment-element-errors"
          );
          i.textContent = n.message, this.$emit("error", n);
          return;
        }
      } catch (n) {
        console.error(n), this.$emit("error", n);
      } finally {
        this.$emit("loading", !1);
      }
    });
  },
  methods: {
    /**
     * Triggers the submission of the form
     * @return {void}
     */
    submit() {
      this.$refs.submitButtonRef.click();
    },
    /**
     * Clears the element
     * @return {void}
     */
    clear() {
      this.element.clear();
    },
    /**
     * Destroys the element
     * @return {void}
     */
    destroy() {
      this.element.destroy();
    },
    /**
     * Focuses on the element
     * @return {void}
     */
    focus() {
      console.warn(
        "This method will currently not work on iOS 13+ due to a system limitation."
      ), this.element.focus();
    },
    /**
     * Collapses the Payment Element into a row of payment method tabs
     * @return {void}
     */
    collapse() {
      this.element.collapse();
    },
    /**
     * Retrieves a previously created element
     */
    getElement() {
      this.element.getElement();
    },
    /**
     * Unmounts the element
     * @return {void}
     */
    unmount() {
      this.element.unmount();
    },
    /**
     * Updates the element. See official docs for more detail: https://site-admin.stripe.com/docs/js/elements_object/update_payment_element
     * @param {string} opts.business.name  Information about your business that will be displayed in the Payment Element. This information will be retrieved from the Stripe account if not provided.
     * @param {array} opts.paymentMethodOrder Sets order in which payment methods are displayed. Otherwise payment methods are ordered dynamically to optimize for conversion.
     * @param {string | Object} opts.fields.billingDetails The Payment Element automatically creates input fields to collect required billing information for some payment methods like SEPA debit. Specify 'never' to avoid collecting billing details in the Payment Element if you're collecting them outside of the Payment Element.
     * @param {string} opts.fields.billingDetails.name Specify 'never' to avoid collecting a name as part of the billing details in the Payment Element.
     * @param {string} opts.fields.billingDetails.email Specify 'never' to avoid collecting an email address as part of the billing details in the Payment Element.
     * @param {string} opts.fields.billingDetails.phone Specify 'never' to avoid collecting a phone number as part of the billing details in the Payment Element.
     * @param {string | Object} opts.fields.billingDetails.address Specify 'never' to avoid collecting an address as part of the billing details in the Payment Element.
     * @param {string} opts.fields.billingDetails.address.line1 Specify 'never' to avoid collecting an address line1 as part of the billing details in the Payment Element.
     * @param {string} opts.fields.billingDetails.address.line2 Specify 'never' to avoid collecting an address line2 as part of the billing details in the Payment Element.
     * @param {string} opts.fields.billingDetails.address.city Specify 'never' to avoid collecting an address city as part of the billing details in the Payment Element.
     * @param {string} opts.fields.billingDetails.address.state Specify 'never' to avoid collecting an address state as part of the billing details in the Payment Element.
     * @param {string} opts.fields.billingDetails.address.country Specify 'never' to avoid collecting an address country as part of the billing details in the Payment Element.
     * @param {string} opts.fields.billingDetails.address.postalCode Specify 'never' to avoid collecting an address postal code as part of the billing details in the Payment Element.
     * @param {string} opts.fields.terms The Payment Element automatically displays mandates or other legal agreements when required by the payment method, like SEPA debit. Specify 'never' to never show legal agreements.
     * @param {string} opts.fields.terms.auBecsDebit Specify 'never' to never show legal agreements for the BECS Debit payment method.
     * @param {string} opts.fields.terms.bancontact Specify 'never' to never show legal agreements for the Bancontact payment method.
     * @param {string} opts.fields.terms.card Specify 'never' to never show legal agreements for the credit card payment method.
     * @param {string} opts.fields.terms.ideal Specify 'never' to never show legal agreements for the iDEAL payment method.
     * @param {string} opts.fields.terms.sepaDebit Specify 'never' to never show legal agreements for the SEPA Debit payment method.
     * @param {string} opts.fields.terms.sofort Specify 'never' to never show legal agreements for the SOFORT payment method.
     * @param {string} opts.fields.terms.usBankAccount Specify 'never' to never show legal agreements for the US Bank accounts payment method.
     * @param {string} opts.wallets Specify 'never' to never show digital wallet payment methods like Apple Pay and Google Pay.
     * @param {string} opts.wallets.applePay Specify 'never' to never show the Apple Pay digital wallet payment method.
     * @param {string} opts.wallets.googlePay Specify 'never' to never show the Google Pay digital wallet payment method.
     */
    update(e) {
      this.element.update(e);
    },
    // events
    onChange(e) {
      this.$emit("element-change", e);
    },
    onReady(e) {
      this.$emit("element-ready", e);
    },
    onFocus(e) {
      this.$emit("element-focus", e);
    },
    onBlur(e) {
      this.$emit("element-blur", e);
    },
    onEscape(e) {
      this.$emit("element-escape", e);
    },
    onClick(e) {
      this.$emit("element-click", e);
    }
  }
}, w = (e) => (v("data-v-e6dc9f8f"), e = e(), g(), e), ge = { id: "stripe-payment-element-form" }, Se = /* @__PURE__ */ w(() => /* @__PURE__ */ l("div", { id: "stripe-payment-element-mount-point" }, null, -1)), be = /* @__PURE__ */ w(() => /* @__PURE__ */ l("div", {
  id: "stripe-payment-element-errors",
  role: "alert"
}, null, -1)), _e = {
  ref: "submitButtonRef",
  type: "submit",
  class: "hide"
};
function Ee(e, t, n, i, r, s) {
  const o = A("mitB");
  return f(), y("div", null, [
    l("form", ge, [
      Se,
      O(o, { name: "stripe-payment-element-errors" }, {
        default: P(() => [
          be
        ]),
        _: 1
      }),
      l("button", _e, null, 512)
    ])
  ]);
}
const ke = /* @__PURE__ */ E(ve, [["render", Ee], ["__scopeId", "data-v-e6dc9f8f"]]), Ae = {
  install: (e, t) => {
    const { pk: n, stripeAccount: i, apiVersion: r, locale: s, elementsOptions: o } = t, p = window.Stripe(n, { stripeAccount: i, apiVersion: r, locale: s });
    p.registerAppInfo(c);
    const I = p.elements(o);
    e.config.globalProperties.$stripe = p, e.config.globalProperties.$stripeElements = I;
  }
};
export {
  Ie as StripeCheckout,
  Ce as StripeElementCard,
  ke as StripeElementPayment,
  Ae as StripeElementsPlugin,
  we as StripePlugin
};
